"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarPower$ = exports.SolarPower$outboundSchema = exports.SolarPower$inboundSchema = void 0;
exports.solarPowerToJSON = solarPowerToJSON;
exports.solarPowerFromJSON = solarPowerFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const meta_js_1 = require("./meta.js");
/** @internal */
exports.SolarPower$inboundSchema = z.object({
    has_solar_power: z.nullable(z.boolean()),
    meta: z.nullable(meta_js_1.Meta$inboundSchema),
    percentage_of_roof_coverage: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "has_solar_power": "hasSolarPower",
        "percentage_of_roof_coverage": "percentageOfRoofCoverage",
    });
});
/** @internal */
exports.SolarPower$outboundSchema = z.object({
    hasSolarPower: z.nullable(z.boolean()),
    meta: z.nullable(meta_js_1.Meta$outboundSchema),
    percentageOfRoofCoverage: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        hasSolarPower: "has_solar_power",
        percentageOfRoofCoverage: "percentage_of_roof_coverage",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SolarPower$;
(function (SolarPower$) {
    /** @deprecated use `SolarPower$inboundSchema` instead. */
    SolarPower$.inboundSchema = exports.SolarPower$inboundSchema;
    /** @deprecated use `SolarPower$outboundSchema` instead. */
    SolarPower$.outboundSchema = exports.SolarPower$outboundSchema;
})(SolarPower$ || (exports.SolarPower$ = SolarPower$ = {}));
function solarPowerToJSON(solarPower) {
    return JSON.stringify(exports.SolarPower$outboundSchema.parse(solarPower));
}
function solarPowerFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SolarPower$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SolarPower' from JSON`);
}
//# sourceMappingURL=solarpower.js.map